import { defineStore } from "pinia";
import { useListInboundDeliveryApi, type ListInboundDeliveryResponse } from "../api/listInboundDeliveryApi";
import { useInboundDeliveryStore } from "./inboundDeliveryStore";
import { useRefreshStore } from "@/common/composables/refreshStore";

export const useRefreshInboundDeliveryStore = defineStore('refresh-inbound-deliveries', () => {
  const listInboundDeliveryApi = useListInboundDeliveryApi();
  const store = useInboundDeliveryStore();

  return useRefreshStore<ListInboundDeliveryResponse>({
    fetchFromServer: () => listInboundDeliveryApi.execute(),
    mergeToStore(response) {
      store.merge(response.deliveries);
    },
  });
});
